module.exports = __webpack_public_path__ + "img/ic-arrow-right-circle.6de3f2d6.svg";